/**
 * INCENTIVE-TRACKER MODULE
 * Self-contained. Import only from /shared or within this module.
 */
import { useNavigate } from "react-router-dom";
import ProgramListPage from "../components/ProgramListPage.jsx";

// Incentive Tracker landing — list of distributor incentive programs.
export default function IncentivePrograms() {
  const navigate = useNavigate();
  return (
    <ProgramListPage
      onHome={() => navigate("/")}
      onOpen={(id) => navigate(`/incentives/${id}`)}
      onDistributorProgress={() => navigate("/incentives/progress")}
    />
  );
}
